import { AbstractControl } from '@angular/forms';

export class ValidatePassword {

  static validate(control: AbstractControl): any {
    const password = control.get('password').value;
    const passwordAgain = control.get('passwordAgain').value;

    if (password !== passwordAgain) {
      control.get('passwordAgain').setErrors({
        MatchPassword: true
      });
    } else if (password === passwordAgain) {
      return null;
    }
  }
}
